export const STYLE_MAP = {
  default: {
    linePaddingLeft: '24px',
    lineMarginRight: '24px',
    mainTextColor: '#616C73',
    backgroundColor: 'rgba(97, 108, 115, 0.08)',
    borderColor: '#c9c9c9',
    promptTextColor: '#616C73'
  },
  diablo: {
    linePaddingLeft: '24px',
    lineMarginRight: '24px',
    mainTextColor: 'rgba(255,255,255,0.6)',
    backgroundColor: 'rgba(162, 164, 165, 0.08)',
    borderColor: '#303538',
    promptTextColor: 'rgba(255,255,255,0.6)'
  },
  colmo: {
    linePaddingLeft: '12px',
    lineMarginRight: '12px',
    mainTextColor: 'rgba(255,255,255,0.4)',
    backgroundColor: '#151617',
    borderColor: 'rgba(255,255,255,0.20)',
    promptTextColor: 'rgba(255,255,255,0.4)'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-status/style.js